export default __webpack_public_path__ + "static/media/PowerGrotesk-Regular.e71d7b0f.otf";